import type { ReactNode } from 'react';

import { H4 } from '#/components/Text/H4';

import { Card_Box_1 } from './Card.styled';
import { Description } from './JobSelector.styled';

type Props = {
  content: {
    name: ReactNode;
    body?: ReactNode;
    description?: string;
  };
  cta?: ReactNode;
};

export function Card({ content: { name, body, description }, cta }: Props) {
  return (
    <Card_Box_1>
      <H4 style={{ marginBottom: 0 }}>{name}</H4>
      {body}
      {description && (
        <Description
          styleAs="bodySmall"
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      )}
      {cta && (
        <div style={{ marginTop: '20px', marginBottom: '15px' }}>{cta}</div>
      )}
    </Card_Box_1>
  );
}
